<div class="admin-container">
  <mat-card class="token-card">
    <mat-card-header>
      <mat-card-title>Admin Panel</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="token-section">
        <h3>API Token</h3>

        <div class="token-display">
          <div class="token-input">
            <input
              type="{{ tokenVisible ? 'text' : 'password' }}"
              [value]="token || ''"
              readonly
              class="token-field"
            />
          </div>

          <div class="token-actions">
            <button
              mat-icon-button
              (click)="toggleTokenVisibility()"
              [attr.aria-label]="tokenVisible ? 'Hide token' : 'Show token'"
              title="{{ tokenVisible ? 'Hide token' : 'Show token' }}"
            >
              <mat-icon>{{ tokenVisible ? 'visibility' : 'visibility_off' }}</mat-icon>
            </button>

            <button
              mat-raised-button
              color="primary"
              (click)="copyToken()"
              title="Copy token to clipboard"
            >
              <mat-icon>content_copy</mat-icon>
              Copy Token
            </button>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div>
